<!-- <template>
  <v-dialog
    :model-value="dialog"
    fullscreen
    persistent
    :overlay="false"
    transition="dialog-transition"
  >
    <v-card elevation="2">
      <v-row
        align="center"
        justify="center"
        :style="{ height: `${VuetifyObj.height}px` }"
        no-gutters
      >
        <v-col cols="12" class="text-center">
          <v-icon
            class="mb-5"
            color="success"
            icon="mdi-check-circle"
            size="112"
          ></v-icon>

          <h2 class="text-h5 mb-6">Registration Successfull</h2>

          <p class="mb-4 text-medium-emphasis text-body-2">
            A confirmation email will be sent to you once the administrator
            approves your registration.
          </p>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    dialog: Boolean,
    VuetifyObj: Object,
  },
};
</script> -->

<template>
  <v-dialog
    :model-value="dialog"
    fullscreen
    persistent
    :overlay="false"
    transition="dialog-transition"
  >
    <v-card elevation="2" class="position-relative">
      <!-- confetti canvas sits on top of the card -->
      <canvas ref="confettiCanvas" class="confetti-canvas" />

      <v-row
        align="center"
        justify="center"
        :style="{ height: '100vh' }"
        no-gutters
      >
        <v-col cols="12" class="text-center">
          <v-icon
            class="mb-5"
            color="success"
            icon="mdi-check-circle"
            size="112"
          />
          <h2 class="text-h5 mb-6">Registration Successful!</h2>
          <p class="mb-4 text-medium-emphasis text-body-2">
            A confirmation email will be sent to you once the administrator
            approves your registration.
          </p>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    VuetifyObj: Object,
  },

  watch: {
    dialog(val) {
      if (val) {
        // ensure DOM updated then fire confetti
        this.$nextTick(() => {
          this.fireConfetti();
        });
      }
    },
  },

  methods: {
    async fireConfetti() {
      try {
        // guard for SSR (window undefined)
        if (typeof window === "undefined") return;

        // dynamic import — safe for SSR builds and avoids bundling issues
        const confettiModule = await import("canvas-confetti");
        const confettiFn = confettiModule.default || confettiModule;

        // create confetti instance bound to our canvas
        const canvas = this.$refs.confettiCanvas;
        if (!canvas) {
          // fallback: call global confetti which will create its own canvas
          confettiFn({
            particleCount: 120,
            spread: 70,
            origin: { y: 0.6 },
          });
          setTimeout(() => {
            confettiFn({
              particleCount: 80,
              spread: 100,
              origin: { y: 0.6 },
            });
          }, 300);
          return;
        }

        const myConfetti = confettiFn.create(canvas, {
          resize: true, // keep canvas sized to container
          useWorker: true, // offload to worker if available
        });

        // two bursts for nice effect
        myConfetti({
          particleCount: 140,
          spread: 70,
          origin: { y: 0.6 },
        });

        setTimeout(() => {
          myConfetti({
            particleCount: 90,
            spread: 100,
            origin: { y: 0.55 },
          });
        }, 300);
      } catch (err) {
        // helpful debug log
        // (if import fails – probably not installed or bundler issue)
        // eslint-disable-next-line no-console
        console.error("Confetti failed:", err);
      }
    },
  },
};
</script>

<style scoped>
/* canvas sits absolute above card so confetti overlays content */
.position-relative {
  position: relative;
}

.confetti-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* clicks pass through */
  z-index: 50;
}
</style>
